import React, { useState } from "react";

// useForm functional component
export const useForm = (callback: any, initialValues: any) => {
    const [formValues, setFormValues] = useState(initialValues);

    // onChange
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues({...formValues, [event.target.name]: event.target.value});
    };

    // onSubmit
    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await callback(); // triggering the callback
    };

    // return values
    return {
        onChange,
        onSubmit,
        formValues,
    };
}